import React from 'react';
export const CustomMapControls = ({ children, className }) => {
    return React.createElement("div", { className: `mapboxgl-ctrl mapboxgl-ctrl-group ${className}` }, children);
};
//# sourceMappingURL=CustomMapControls.js.map